const cards = [
  {
    title: '霸道总裁的契约恋人',
    category: '韩漫腐 · 都市',
    desc: '一场契约婚姻，两个世界的人意外交集。高冷总裁与温柔设计师的拉扯日常，甜蜜又虐心。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20style%20illustration%20of%20two%20handsome%20men%20in%20modern%20business%20suits%2C%20one%20tall%20and%20stern%20looking%2C%20the%20other%20gentle%20with%20soft%20eyes%2C%20city%20skyline%20at%20sunset%20in%20background%2C%20romantic%20Korean%20webtoon%20art%20style%2C%20soft%20warm%20lighting%2C%20clean%20composition&width=600&height=800&seq=card-manga-01&orientation=portrait',
    tag: '热门推荐',
  },
  {
    title: '剑影风华录',
    category: '国漫耽美 · 古风',
    desc: '江湖纷争中，正道大侠与魔教少主的禁忌之恋。刀光剑影之下，唯情字难解。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20style%20manga%20illustration%20of%20two%20male%20swordsmen%20in%20flowing%20traditional%20hanfu%20robes%2C%20long%20black%20hair%2C%20standing%20on%20a%20misty%20mountain%20peak%20with%20cherry%20blossom%20trees%2C%20elegant%20and%20romantic%20atmosphere%2C%20soft%20watercolor%20style&width=600&height=800&seq=card-manga-02&orientation=portrait',
    tag: '新作上线',
  },
  {
    title: '樱花树下的约定',
    category: '日漫腐 · 校园',
    desc: '高中最后一年，沉默寡言的学霸与活泼开朗的体育生，在樱花纷飞的季节许下青春的誓言。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20two%20high%20school%20boys%20in%20uniform%20under%20a%20large%20cherry%20blossom%20tree%2C%20one%20with%20glasses%20holding%20a%20book%2C%20the%20other%20smiling%20brightly%2C%20pink%20petals%20falling%2C%20spring%20sunlight%2C%20nostalgic%20and%20warm&width=600&height=800&seq=card-manga-03&orientation=portrait',
    tag: '经典必读',
  },
  {
    title: '异世界魔王的宠妃',
    category: '韩漫耽美 · 奇幻',
    desc: '穿越异世界成为魔王祭品，却意外被魔王捧在手心。华丽魔法世界中的极致宠溺。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20illustration%20of%20a%20handsome%20dark-haired%20demon%20king%20in%20ornate%20black%20and%20gold%20armor%2C%20holding%20a%20beautiful%20young%20man%20in%20white%20robes%2C%20magical%20sparks%20and%20crystal%20floating%20around%2C%20dark%20gothic%20castle%20background%2C%20dramatic%20lighting&width=600&height=800&seq=card-manga-04&orientation=portrait',
    tag: '连载中',
  },
  {
    title: '恋爱吧少年',
    category: '国漫耽美 · 青春',
    desc: '两个热爱篮球的少年从对手到队友再到恋人，汗水与泪水交织的青春热血故事。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20manga%20style%20illustration%20of%20two%20athletic%20teenage%20boys%20in%20basketball%20jerseys%2C%20one%20dribbling%20the%20ball%2C%20the%20other%20reaching%20out%20to%20block%2C%20sunlit%20outdoor%20basketball%20court%2C%20dynamic%20pose%2C%20warm%20summer%20afternoon%20light&width=600&height=800&seq=card-manga-05&orientation=portrait',
    tag: '评分9.5',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队为你精心挑选的优质腐漫作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-400 whitespace-nowrap">{card.category}</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}